export default "__VITE_ASSET__tBsG7vGw__"